import React from 'react';
import { useUserSettingsContext } from 'users/utils/contexts/UserSettingsContext';

const CustomYAxisTick: React.FC<{
  x: number;
  y: number;
  payload: { value: string | number };
  fill: string;
}> = ({ x, y, payload, fill }) => {
  const { getCurrencyNumber } = useUserSettingsContext();
  return (
    <text x={x} y={y} fill={fill} textAnchor="end">
      {getCurrencyNumber(payload.value)}
    </text>
  );
};

export default CustomYAxisTick;
